export default __webpack_public_path__ + "static/media/pediasure600.cdf9e435.jpg";